import type { PaymentFingerprint } from '@src/domains/payments';

const CYBERSOURCE = 'cybersource';
const CLEARSALE = 'clearsale';

export const setupFingerprint = ({ type, data }: PaymentFingerprint) => {
  switch (type) {
    case CYBERSOURCE:
      const script = document.createElement('script');
      script.src = data['url'];
      document.body.appendChild(script);

      break;
    case CLEARSALE:
      // Reference: https://api.clearsale.com.br/docs/behavior-analytics/sdk/browser
      (function (a: any, b: any, c: any, d: any, e: any, f?: any, g?: any) {
        a['CsdpObject'] = e;
        (a[e] =
          a[e] ||
          function () {
            (a[e].q = a[e].q || []).push(arguments);
          }),
          (a[e].l = +new Date());
        (f = b.createElement(c)), (g = b.getElementsByTagName(c)[0]);
        f.async = 1;
        f.src = d;
        g.parentNode.insertBefore(f, g);
      })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
      const wdw: any = window;
      wdw.csdp('app', data['app']);
      wdw.csdp('sessionid', data['sessionid']);

      // Reference: https://www2.clear.sale/developers/api#appendix-order
      (function (a: any, b: any, c: any, d: any, e: any, f?: any, g?: any) {
        a['CsdmObject'] = e;
        (a[e] =
          a[e] ||
          function () {
            (a[e].q = a[e].q || []).push(arguments);
          }),
          (a[e].l = 1 * (new Date() as any));
        (f = b.createElement(c)), (g = b.getElementsByTagName(c)[0]);
        f.async = 1;
        f.src = d;
        g.parentNode.insertBefore(f, g);
      })(window, document, 'script', '//device.clearsale.com.br/m/cs.js', 'csdm');
      wdw.csdm('app', data['app']);
      wdw.csdm('mode', 'manual');
      wdw.csdm('send');

      break;
  }
};
